import { Action } from 'redux';

export const ACTION_ADD = 'add';
export type ActionAddAction = Action<typeof ACTION_ADD>;
export const ACTION_COPY = 'copy';
export type ActionCopyAction = Action<typeof ACTION_COPY>;
export const ACTION_MOVE = 'move';
export type ActionMoveAction = Action<typeof ACTION_MOVE>;
export const ACTION_REMOVE = 'remove';
export type ActionRemoveAction = Action<typeof ACTION_REMOVE>;
export const ACTION_SET = 'set';
export type ActionSetAction = Action<typeof ACTION_SET>;
export const ACTION_INCREASE = 'increase';
export type ActionIncreaseAction = Action<typeof ACTION_INCREASE>;
export const ACTION_DECREASE = 'decrease';
export type ActionDecreaseAction = Action<typeof ACTION_DECREASE>;
export const ACTION_LOCK_SCREEN = 'LOCK_SCREEN';
export type ActionLockScreenAction = Action<typeof ACTION_LOCK_SCREEN>;
export const ACTION_UNLOCK_SCREEN = 'UNLOCK_SCREEN';
export type ActionUnlockScreenAction = Action<typeof ACTION_UNLOCK_SCREEN>;
export const ACTION_CHANGE_PRICE = 'changePrice';

export type ListContentAction =
    | typeof ACTION_ADD
    | typeof ACTION_COPY
    | typeof ACTION_MOVE
    | typeof ACTION_REMOVE
    | typeof ACTION_SET
    | typeof ACTION_INCREASE
    | typeof ACTION_DECREASE
    | typeof ACTION_CHANGE_PRICE;

export const SOURCE_CATALOGUE = 'catalogue';
export const SOURCE_CART = 'shoppingcart';
export const SOURCE_SELECTIONLIST = 'selectionlist';
export const SOURCE_BUNDLE = 'bundle';
export const SOURCE_QUANTITY = 'quantity';
export const SOURCE_COLLECTION = 'cc';
export const SOURCE_COLLECTION_NEWLY_ADDED = 'cc_newly_added';
export const SOURCE_COLLECTION_BY_GENRE = 'cc_by_genre';

export const SOURCE_LOTE_PRODUCTS = 'lote';
export const SOURCE_LOTE_NEWLY_ADDED = 'lote_newly_added';
export const SOURCE_LOTE_GENRE = 'lote_by_genre';

export const SOURCE_LANGUAGE_LEARNING_PRODUCTS = 'll';
export const SOURCE_LANGUAGE_LEARNING_NEWLY_ADDED = 'll_newly_added';

export const SOURCE_CAMPAIGN_PRODUCTS = 'campaign_products';
export const SOURCE_PRODUCT_GROUPS = 'productgroup';

export type ListContentSource =
    | typeof SOURCE_CATALOGUE
    | typeof SOURCE_CART
    | typeof SOURCE_SELECTIONLIST
    | typeof SOURCE_BUNDLE
    | typeof SOURCE_QUANTITY
    | typeof SOURCE_COLLECTION
    | typeof SOURCE_COLLECTION_NEWLY_ADDED
    | typeof SOURCE_COLLECTION_BY_GENRE
    | typeof SOURCE_LOTE_PRODUCTS
    | typeof SOURCE_LOTE_NEWLY_ADDED
    | typeof SOURCE_LOTE_GENRE
    | typeof SOURCE_LANGUAGE_LEARNING_PRODUCTS
    | typeof SOURCE_LANGUAGE_LEARNING_NEWLY_ADDED
    | typeof SOURCE_CAMPAIGN_PRODUCTS
    | typeof SOURCE_PRODUCT_GROUPS;

export const GROUPBY_PRODUCTS = 'products';
export const GROUPBY_BUNDLES = 'bundles';
export const GROUPBY_LISTS = 'selectionlists';
export type GroupBy = typeof GROUPBY_BUNDLES | typeof GROUPBY_LISTS | typeof GROUPBY_PRODUCTS;

export const PATH_CATALOGUE = '/catalogue';
export const PATH_SEARCH = '/search';
export const PATH_PRODUCTS = '/products';
export const PATH_SELECTIONLISTS = '/orderlists';
export const PATH_BUNDLES = '/bundles';
export const PATH_CART = '/cart';
export const PATH_CHECKOUT = '/checkout';
export const PATH_RESERVE_CHECKOUT = '/checkout';
export const PATH_ORDERS = '/orders';
export const PATH_ASSISTANT = '/assistant';
export const PATH_RESERVE = '/assistant/reserve';
export const PATH_COLLECTION = '/collection';
export const PATH_BY_GENRE = '/by-genre';
export const PATH_NEWLY_ADDED = '/newly-added';
export const PATH_LOCAL_CONTENT = '/localcontent';

export const PRODUCT_CLASS_STANDARD = 'STANDARD';
export const PRODUCT_CLASS_LOTE = 'LOTE';
export const PRODUCT_CLASS_LANGUAGE_LEARNING = 'LANGUAGE_LEARNING';
export const PRODUCT_CLASS_CAMPAIGN = 'CAMPAIGN';

// TODO: product class is hard set and does not come from the backend
// because currently it't only set and uses as a constant to make
// components using the prop productClass more consistent and safer
// for the future. Adapt when it's added in LC product service someday
export const PRODUCT_CLASS_LOCAL = 'LOCAL';

export type ProductClass =
    | typeof PRODUCT_CLASS_STANDARD
    | typeof PRODUCT_CLASS_LOTE
    | typeof PRODUCT_CLASS_LANGUAGE_LEARNING
    | typeof PRODUCT_CLASS_CAMPAIGN
    | typeof PRODUCT_CLASS_LOCAL;

export const LENDING_MODEL_OCOU = 'OCOU';
export const LENDING_MODEL_SIM = 'SIM';

export const UNLIMITED_USAGE_LIMIT = 0;
